import { render, staticRenderFns } from "./upShopHouseManage.vue?vue&type=template&id=2a7a599b&scoped=true"
import script from "./upShopHouseManage.vue?vue&type=script&lang=js"
export * from "./upShopHouseManage.vue?vue&type=script&lang=js"
import style0 from "./upShopHouseManage.vue?vue&type=style&index=0&id=2a7a599b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7a599b",
  null
  
)

export default component.exports